<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { printPhone } from '@/utils/phones'
import ButtonCallTo from '@/components/common/buttons/ButtonCallTo.vue'
import ButtonMailTo from '@/components/common/buttons/ButtonMailTo.vue'
import { DevicePhoneMobileIcon, TrashIcon, PencilIcon } from '@heroicons/vue/24/outline'
import {  ListBulletIcon } from '@heroicons/vue/24/outline'
import IconWithTooltip from '@/components/common/ui/IconWithTooltip.vue'
import { usePartnerStore } from '@/stores/usePartnerStore'

const props = defineProps(['params'])
const router = useRouter()
const partnerStore = usePartnerStore()

const row = computed(() => props.params?.data)
const contactUuid = computed(() => row.value?.uuid)
const hasUuid = computed(() => !!row.value?.uuid)

const partnerId = ref()
const phone = ref()
const mobile = ref()
const email = ref()
const active = ref()

onMounted(() => {
  partnerId.value = row.value?.parentId?.id || (row.value?.company?.referenceExterne)
  phone.value = row.value?.phone
  mobile.value = row.value?.mobile
  email.value = row.value?.email
  active.value = row.value?.active !== false
})

function onEdit() {
  if (!contactUuid.value) {
    // Fallback if no UUID but has standard onClick callback
    if (props.params?.onClick) {
      props.params.onClick(row.value)
    }
    return
  }
  router.push(`/dashboard/contacts/${contactUuid.value}`)
}

async function onNewTodo() {
  if(row.value.parentId)
    row.value.company = await partnerStore.fetchCompanyByOdooRef(row.value.parentId.id)

  if (props.params?.onClickNewTodo) {
    props.params.onClickNewTodo(row.value)
  }
}

function onDelete() {
  if (props.params?.onClickBtnDelete) {
    props.params.onClickBtnDelete(row.value)
  }
}
</script>

<template>
  <div class="flex items-center justify-end gap-2 w-full">
    <!-- To Do -->
    <div class="w-fit">
      <IconWithTooltip
        text="Nouveau To Do"
        :tooltip-position="params.tooltipPosition || 'top'"
        @click="onNewTodo"
      >
        <ListBulletIcon class="h-4 w-4" />
      </IconWithTooltip>
    </div>

    <!-- Call Fixed -->
    <div class="w-fit">
      <ButtonCallTo
        :disabled="!phone"
        :partner-id="partnerId"
        :contact-id="row?.id"
        :phone="printPhone(phone)"
        :tooltip-position="params.tooltipPosition || 'top'"
      />
    </div>

    <!-- Call Mobile -->
    <div class="w-fit">
      <ButtonCallTo
        :disabled="!mobile"
        :partner-id="partnerId"
        :contact-id="row?.id"
        :phone="printPhone(mobile)"
        :icon="DevicePhoneMobileIcon"
        :tooltip-position="params.tooltipPosition || 'top'"
      />
    </div>

    <!-- Mail -->
    <div class="w-fit">
      <ButtonMailTo
        :disabled="!email"
        :email="email"
        :tooltip-position="params.tooltipPosition || 'top'"
      />
    </div>

    <!-- Edit -->
    <div v-if="hasUuid" class="w-fit">
      <IconWithTooltip
        text="Modifier"
        :tooltip-position="params.tooltipPosition || 'top'"
        @click="onEdit"
      >
        <PencilIcon class="h-4 w-4" />
      </IconWithTooltip>
    </div>

    <!-- Delete -->
    <div v-if="hasUuid" class="w-fit">
      <IconWithTooltip
        text="Archiver"
        variant="error"
        :tooltip-position="params.tooltipPosition || 'top'"
        :disabled="!active"
        @click="onDelete"
      >
        <TrashIcon class="h-4 w-4 " />
      </IconWithTooltip>
    </div>
  </div>
</template>
